export const VIEW_MODE_SITE = 'site';
export const VIEW_MODE_EDITOR = 'editor';
export const VIEW_MODE_PREVIEW = 'preview';
export const VIEW_MODE_DASHBOARD = 'dashboard';
